<script>
// Afficher conditionnellement le premier enfant de ce composant.
// Inspiration: https://forum.vuejs.org/t/conditionally-render-parent-element/9324/2

export default {
  name: 'WithRoot',
  functional: true,
  props: ['show'],
  render(h, ctx) {
    const children = ctx.children.filter((vnode) => vnode.tag); // remove unnecessary text nodes
    if (children.length !== 1) {
      console.warn("Le component 'WithRoot' n'accepte qu'un seul noeud racine dans sa 'slot'");
    }
    if (ctx.props.show) {
      return children[0];
    }
    return children[0].children;
  },
};
</script>
